import { useState } from 'react';
import api from '../api';

function GstinLookup({ gstin, onFetched, variant = 'button' }) {
  const [status, setStatus] = useState('idle'); // idle | loading | success | fail
  const [message, setMessage] = useState('');

  const handleFetch = () => {
    if (!gstin || !gstin.trim()) {
      setStatus('fail');
      setMessage('Enter a GSTIN first.');
      return;
    }
    setStatus('loading');
    setMessage('');
    api
      .get(`/gst/lookup/${gstin.trim()}`)
      .then((res) => {
        if (res.data.found) {
          setStatus('success');
          onFetched(res.data);
        } else {
          setStatus('fail');
          setMessage(res.data.message || 'Could not fetch details automatically. Please enter manually.');
        }
      })
      .catch(() => {
        setStatus('fail');
        setMessage('Could not fetch details automatically. Please enter manually.');
      });
  };

  if (variant === 'link') {
    return (
      <div className="gstin-lookup-link-wrap">
        <button type="button" className="gstin-lookup-link" onClick={handleFetch} disabled={status === 'loading'}>
          {status === 'loading' ? 'Fetching from GST portal...' : 'Or fetch automatically from GST portal →'}
        </button>
        {status === 'success' && <p className="gstin-status success">Details fetched from GST portal ✓</p>}
        {status === 'fail' && <p className="gstin-status fail">{message}</p>}
      </div>
    );
  }

  return (
    <div className="gstin-lookup-inline">
      <button
        type="button"
        className="dash-btn dash-btn-outline"
        onClick={handleFetch}
        disabled={status === 'loading'}
      >
        {status === 'loading' ? 'Fetching...' : 'Fetch Details'}
      </button>
      {status === 'success' && <span className="gstin-status success">Details fetched from GST portal ✓</span>}
      {status === 'fail' && <span className="gstin-status fail">{message}</span>}
    </div>
  );
}

export default GstinLookup;
